import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

interface PhilosophyArticleProps {
  numeral: string;
  title: string;
  description: string;
}

const PhilosophyArticle: React.FC<PhilosophyArticleProps> = ({ numeral, title, description }) => {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <div className="philosophy-article" ref={ref}>
      <div className="philosophy-article-numeral">{numeral}</div>
      <div className="philosophy-article-body">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default PhilosophyArticle;
